import { render, staticRenderFns } from "./fade-overlay.vue?vue&type=template&id=cffbbd84&scoped=true&"
import script from "./fade-overlay.vue?vue&type=script&lang=ts&"
export * from "./fade-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./fade-overlay.vue?vue&type=style&index=0&id=cffbbd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffbbd84",
  null
  
)

export default component.exports